import config from "../config";

/**
 * POST /_/heartbeat to refresh the edge cookie.
 * Fail-open: catches all errors, never throws.
 */
export async function sendHeartbeat() {
  try {
    await fetch(config.sessionEdge.heartbeatPath, {
      method: "POST",
      credentials: "include",
    });
  } catch (err) {
    console.warn("[sessionEdge] heartbeat failed:", err);
  }
}

/**
 * Expire the vc_last_activity cookie.
 */
export function clearSessionCookie() {
  const parts = [
    config.sessionEdge.cookieName + "=",
    "Path=/",
    "Max-Age=0",
    "SameSite=Lax",
  ];

  const domain = config.sessionEdge.cookieDomain;
  if (domain && domain !== "localhost") {
    parts.push("Domain=" + domain);
  }

  if (window.location.protocol === "https:") {
    parts.push("Secure");
  }

  document.cookie = parts.join("; ");
}

/**
 * Check if edge session management is enabled.
 */
export function isEdgeSessionEnabled() {
  return Boolean(config.sessionEdge.enabled);
}
